/* tslint:disable */
/* eslint-disable */
/**
 * Main data new API
 * Auto-generated openapi scheme for main-data-new API
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GDPRDryRun
 */
export interface GDPRDryRun {
    /**
     * 
     * @type {number}
     * @memberof GDPRDryRun
     */
    clientId: number;
    /**
     * 
     * @type {boolean}
     * @memberof GDPRDryRun
     */
    dryRun: boolean;
}

export function GDPRDryRunFromJSON(json: any): GDPRDryRun {
    return GDPRDryRunFromJSONTyped(json, false);
}

export function GDPRDryRunFromJSONTyped(json: any, ignoreDiscriminator: boolean): GDPRDryRun {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'clientId': json['client_id'],
        'dryRun': json['dry_run'],
    };
}

export function GDPRDryRunToJSON(value?: GDPRDryRun | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'client_id': value.clientId,
        'dry_run': value.dryRun,
    };
}


